import { type Schemas } from "@/types";
import { Badge, Box, Flex, SimpleGrid, Stack, Text } from "@mantine/core";

import classes from "../..//Home.module.css";
import { IconDots } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { lowerCaseNthLetter } from "@/utils/filters";
import { useNavigate } from "react-router-dom";

interface ActiveCasesItemProps {
  currentCase: Schemas["CaseRetrieveDto"];
}

export default function ActiveCasesItem2({
  currentCase,
}: ActiveCasesItemProps) {
  const { t } = useTranslation("features");
  const navigate = useNavigate();

  return (
    <Box
      className={classes.listItem}
      onClick={() => {
        navigate(`/app/cases/${currentCase?.id}`);
      }}
    >
      <Flex justify="space-between" align="center" direction="row" mb={4}>
        <Flex justify="flex-start" align="center" direction="row" gap={8}>
          <Text className={classes.listItemTitle}>{currentCase.subject}</Text>
          <Badge variant="light">
            {t(`cases.${lowerCaseNthLetter(currentCase.status!)}`)}
          </Badge>
        </Flex>
        <IconDots width={20} height={20} style={{ display: "none" }} />
      </Flex>
      <SimpleGrid cols={{ xs: 2, sm: 2, md: 3, lg: 6, xl: 6 }} spacing={8}>
        <Stack gap={0}>
          <Text className={classes.listItemLabel}>{t(`cases.number`)}</Text>
          <Text className={classes.listItemText}>
            {currentCase.number ?? ""}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text className={classes.listItemLabel}>
            {t(`cases.senderEmail`)}
          </Text>
          <Text className={classes.listItemText}>
            {currentCase.senderEmail ?? ""}
          </Text>
        </Stack>
      </SimpleGrid>
    </Box>
  );
}
